import React from 'react'
import Hero from '../Hero'
import Timez from '../Timez'
import NextSection from '../Nextsection'
import TestimonialsCarousel from '../TestimonialsCarousel'
import Footer from '../Footer'
import BrandsSection from '../BrandSection'
import ProcessSection from '../Process'


const Landing = () => {
  return (
  <>
          <Hero />
                <Timez />
                <NextSection />
                <ProcessSection/>
                <BrandsSection />
           
          
            
                </>
  )
}

export default Landing